// import clsx from 'clsx';
// import {LandingPageContent} from './landing-page-content';
// import {Navbar} from '@common/ui/navigation/navbar/navbar';
// import {Button, ButtonProps} from '@ui/buttons/button';
// import {IconButton} from '@ui/buttons/icon-button';
// import {KeyboardArrowDownIcon} from '@ui/icons/material/KeyboardArrowDown';
// // import {Footer} from '@common/ui/footer/footer';
// import {Trans} from '@ui/i18n/trans';
// import {AdHost} from '@common/admin/ads/ad-host';
// import {Link} from 'react-router-dom';
// import {createSvgIconFromTree} from '@ui/icons/create-svg-icon';
// import {MenuItemConfig} from '@common/menus/menu-config';
// import {Fragment} from 'react';
// import {DefaultMetaTags} from '@common/seo/default-meta-tags';
// import {useTrans} from '@ui/i18n/use-trans';
// import {useSettings} from '@ui/settings/use-settings';
// import {MixedImage} from '@ui/images/mixed-image';


import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import TrustedLogo from './components/TrustedLogo/TrustedLogo';
import './components/new-landing-page.css';


export function LandingPage() {

  return (
    <> 
          <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
        rel="stylesheet"
      />
      <script
        src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js"
        async
      ></script>
      

    <Header/>

    {/* Banner section */}
    <div className="container-fluid">
        <div className="row">
            <a href="/register">
            <img src="images/assets/banner.png" alt='banner' width={"100%"} />
            </a>
        </div>
    </div>
    <section className="serviceSection">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 col-lg-3">
            <div className="block">
              <div className="innerBlock">
                <img src="images/assets/store-file.png" alt='store-file' width={"120"} />
                <h4>Store any file</h4>
                <p>Keep photos, stories, designs, drawings recordings, videos & more. Your first 15 GB of storage are free.</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3">
            <div className="block">
              <div className="innerBlock">
                <img src="images/assets/staff.png" alt='staff' width={"120"} />
                <h4>See your stuff anywhere</h4>
                <p>Your files in cloudegy can be reached from any smartphone, tablet or computer.</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3">
            <div className="block">
              <div className="innerBlock">
                <img src="images/assets/share-folder.png" alt='share-folder' width={"120"} />
                <h4>Share files & folders</h4>
                <p>You can quickly invite others to view download, and collaborate on all the files you want.</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3">
            <div className="block">
              <div className="innerBlock">
                <img src="images/assets/unlimited-backup.png" alt='unlimited-backup' width={"120"} />
                <h4>Unlimited Computer Backup</h4>
                <p>Protect business or home workstations with automatic, unlimited, secure backups for your files in the cloud.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Computer Backup Section */}
    <section className="computerBackupSection">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-md-6 col-lg-6 pl-0">
            <div className="block">
              <h5>COMPUTER BACKUP</h5>
              <h3>Unlimited, Automatic, Easy Data Protection</h3>
              <p>
                Protect your business, your memories, or both with the world’s easiest backup for macs and pcs—secure in the trusted Cloudedge Technology storage cloud & customizable for one or one thousand computers.
              </p>
              <a href="#">Project With Computer Backup</a>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-6 text-center">
            <img src="images/assets/computer-backup-graphics.png" alt='computer-backup-graphics' style={{maxWidth:"458px"}} />
          </div>
        </div>
      </div>
    </section>

    {/* Computer Backup Section */}
    <section className="computerBackupSection cloudStorage">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-md-6 col-lg-6 text-center">
            <img src="images/assets/cloude-storage.png" alt='cloude-storage' style={{maxWidth:"458px"}} />
          </div>
          <div className="col-12 col-md-6 col-lg-6 pr-0">
            <div className="block">
              <h5>B2 CLOUD STORAGE</h5>
              <h3>S3 Compatible Object Storage Without S3 Limits</h3>
              <p>
              Always-Hot Storage For Building Applications, Creating & Serving Content, And Safeguarding Your Data At 1/5 The Cost Of Legacy Providers. Whatever Solution Or Use Case, B2 Cloud Storage Is Open For Business.
              </p>
              <a href="/login">Scale With B2 Cloud Storage</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Benefits section start */}
    <section className="benefitSection">
      <div className="container">
        <h3><span>BENEFITS OF</span> Enterprise Grade Platform, Accessible For Everyone</h3>
        <div className="row">
          <div className="col-12 col-md-6 col-lg-4">
            <div className="block">
              <img src="images/assets/securing.png" alt='securing' width={"66"} />
              <h4>Securing Every Byte</h4>
              <p>There’s no lock-in, but Cloudedge Technology security is lock-tight.</p>
              <a href="/login">Explore Cloud Security</a>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="block">
              <img src="images/assets/built-performance.png" alt='built-performance' width={"66"} />
              <h4>Built For Performance</h4>
              <p>The Cloudedge Technology storage cloud is built to deliver all the performance at ⅕ cost.</p>
              <a href="/login">Learn How We Do It</a>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="block">
              <img src="images/assets/backing.png" alt='backing' width={"66"} />
              <h4>Backing Up Your Backup</h4>
              <p>Backups Protect Your Data; Account Security Protects Your Backups.</p>
              <a href="/login">Explore Backup Security</a>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="block">
              <img src="images/assets/clock.png" alt='clock' width={"66"} />
              <h4>24 Hours Support</h4>
              <p>From solution engineers to support techs, actual humans are here to help.</p>
              <a href="#">Get Help</a>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="block">
              <img src="images/assets/providing.png" alt='providing' width={"66"} />
              <h4>Providing Actual Privacy</h4>
              <p>The cloud is the only thing on sale, not customer data. PII safety is A top priority.</p>
              <a href="#">Privacy Policy</a>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="block">
              <img src="images/assets/scaling.png" alt='scaling' width={"66"} />
              <h4>Scaling Compliance</h4>
              <p>backblaze is compliant for most use cases, and steadily adding certifications.</p>
              <a href="/login">Explore Compliances</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Get started section */}
    <section className="getStartedSection">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 col-lg-8">
            <div className="block">
              <h4>Get Started With Cloudegy</h4>
              <p>lorem ipsum is placeholder text commonly used in the graphic print and publishing industries for previewing layouts and visual mockups.</p>
              <a href="/register">Free Signup</a>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <img src="images/assets/get-started-img.png" alt='store-file' width={"454"} className="getStartedImg" />
          </div>
        </div>
      </div>
    </section>

    <TrustedLogo/>
    <Footer/>
    </>
  );
//   return (
//     <Fragment>
//       <DefaultMetaTags />
//       <div>
//         <HeroHeader content={homepage.appearance} />
//         <AdHost slot="landing-top" className="mb-14 px-14 md:mb-60" />
//         <PrimaryFeatures content={homepage.appearance} />
//         <div className="my-40 h-1 bg-divider" />
//         <SecondaryFeatures content={homepage.appearance} />
//         <BottomCta content={homepage.appearance} />
//         <Footer className="landing-container" />
//       </div>
//     </Fragment>
//   );
// }

// function HeroHeader({
//   content: {
//     headerTitle,
//     headerSubtitle,
//     headerImage,
//     headerImageOpacity,
//     actions,
//     headerOverlayColor1,
//     headerOverlayColor2,
//   },
// }: ContentProps) {
//   const {trans} = useTrans();

//   let overlayBackground = undefined;

//   if (headerOverlayColor1 && headerOverlayColor2) {
//     overlayBackground = `linear-gradient(45deg, ${headerOverlayColor1} 0%, ${headerOverlayColor2} 100%)`;
//   } else if (headerOverlayColor1) {
//     overlayBackground = headerOverlayColor1;
//   } else if (headerOverlayColor2) {
//     overlayBackground = headerOverlayColor2;
//   }

//   return (
//     <header
//       className="relative mb-14 h-500 md:mb-60 md:h-screen"
//       style={{background: overlayBackground}}
//     >
//       <div
//         data-testid="headerImage"
//         className="absolute inset-0 z-10 bg-cover bg-1/2 bg-no-repeat md:bg-fixed"
//         style={{
//           backgroundImage: `url(${headerImage})`,
//           opacity: headerImageOpacity,
//         }}
//       />
//       <div className="relative z-20 flex h-full flex-col">
//         <Navbar
//           color="transparent"
//           className="flex-shrink-0"
//           menuPosition="homepage-navbar"
//         />
//         <div className="mx-auto flex max-w-850 flex-auto flex-col items-center justify-center px-14 text-center text-white">
//           {headerTitle && (
//             <h1
//               className="text-4xl font-medium md:text-5xl"
//               data-testid="headerTitle"
//             >
//               <Trans message={headerTitle} />
//             </h1>
//           )}
//           {headerSubtitle && (
//             <div
//               className="mt-30 text-lg md:mt-10 md:text-xl"
//               data-testid="headerSubtitle"
//             >
//               <Trans message={headerSubtitle} />
//             </div>
//           )}
//           <div className="mt-30 flex min-h-50 gap-20">
//             <CtaButton
//               item={actions?.cta1}
//               variant="raised"
//               color="primary"
//               size="lg"
//               radius="rounded-full"
//               data-testid="cta1"
//               className="min-w-180"
//             />
//             <CtaButton
//               item={actions?.cta2}
//               variant="text"
//               color="paper"
//               size="lg"
//               radius="rounded-full"
//               data-testid="cta2"
//             />
//           </div>
//         </div>
//       </div>
//       <IconButton
//         size="lg"
//         className="absolute bottom-5 left-0 right-0 z-30 mx-auto text-white max-md:hidden"
//         elementType="a"
//         aria-label={trans({message: 'View features'})}
//         href="#primary-features"
//       >
//         <KeyboardArrowDownIcon />
//       </IconButton>
//     </header>
//   );
// }

// interface CtaButtonProps extends ButtonProps {
//   item?: MenuItemConfig;
// }
// function CtaButton({item, ...buttonProps}: CtaButtonProps) {
//   if (!item?.label) return null;
//   const Icon = item.icon ? createSvgIconFromTree(item.icon) : undefined;
//   return (
//     <Button
//       elementType={item.type === 'route' ? Link : 'a'}
//       href={item.action}
//       to={item.action}
//       startIcon={Icon ? <Icon /> : undefined}
//       {...buttonProps}
//     >
//       <Trans message={item.label} />
//     </Button>
//   );
// }

// function PrimaryFeatures({content}: ContentProps) {
//   return (
//     <div
//       className="landing-container items-stretch gap-26 md:flex"
//       id="primary-features"
//     >
//       {content?.primaryFeatures?.map((feature, index) => (
//         <div
//           key={index}
//           className="mb-14 flex-1 rounded-2xl px-24 py-36 text-center shadow-[0_10px_30px_rgba(0,0,0,0.08)] md:mb-0"
//           data-testid={`primary-root-${index}`}
//         >
//           <MixedImage
//             className="mx-auto mb-30 h-128"
//             data-testid={`primary-image-${index}`}
//             src={feature.image}
//           />
//           <h2
//             className="my-16 text-lg font-medium"
//             data-testid={`primary-title-${index}`}
//           >
//             <Trans message={feature.title} />
//           </h2>
//           <div
//             className="text-md text-[0.938rem]"
//             data-testid={`primary-subtitle-${index}`}
//           >
//             <Trans message={feature.subtitle} />
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }

// function SecondaryFeatures({content}: ContentProps) {
//   return (
//     <div className="landing-container">
//       {content?.secondaryFeatures?.map((feature, index) => {
//         const isEven = index % 2 === 0;
//         return (
//           <div
//             key={index}
//             data-testid={`secondary-root-${index}`}
//             className={clsx(
//               'mb-14 py-16 md:mb-80 md:flex',
//               isEven && 'flex-row-reverse',
//             )}
//           >
//             <img
//               src={feature.image}
//               className="mr-auto w-580 max-w-full rounded-lg shadow-[0_10px_30px_rgba(0,0,0,0.08)]"
//               data-testid={`secondary-image-${index}`}
//               alt=""
//             />
//             <div className="ml-30 mr-auto max-w-350 pt-30">
//               <small
//                 className="mb-16 text-xs font-medium uppercase tracking-widest text-muted"
//                 data-testid={`secondary-subtitle-${index}`}
//               >
//                 <Trans message={feature.subtitle} />
//               </small>
//               <h3
//                 className="py-16 text-3xl"
//                 data-testid={`secondary-title-${index}`}
//               >
//                 <Trans message={feature.title} />
//               </h3>
//               <div className="h-2 w-50 bg-black/90" />
//               <div
//                 className="my-20 text-[0.938rem]"
//                 data-testid={`secondary-description-${index}`}
//               >
//                 <Trans message={feature.description} />
//               </div>
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// function BottomCta({content}: ContentProps) {
//   return (
//     <div
//       className="relative bg-[#2B2B2B] bg-no-repeat py-70 text-center text-on-primary md:bg-fixed"
//       style={{backgroundImage: `url("${content.footerImage}")`}}
//       data-testid="footerImage"
//     >
//       <h2
//         className="mx-auto max-w-620 text-3xl font-normal"
//         data-testid="footerTitle"
//       >
//         <Trans message={content.footerTitle} />
//       </h2>
//       {content.footerSubtitle && (
//         <p
//           className="mx-auto mt-50 max-w-620 text-2xl font-normal"
//           data-testid="footerSubtitle"
//         >
//           <Trans message={content.footerSubtitle} />
//         </p>
//       )}
//       <CtaButton
//         item={content.actions?.cta3}
//         size="lg"
//         variant="outline"
//         color="paper"
//         className="mt-50 block"
//         data-testid="cta3"
//       />
//     </div>
//   );
}
